export default {
  CLEAR_TEXT:
    '{this.name === "VehicleWidgetDialog" ? "Clear" : "Reset"}<rt-virtual template="icons/reset" />',
  GO_TEXT: '{this.name === "HomeVehicleWidget" ? "Select your vehicle" : "GO"}',
  CHANGE_TEXT: 'Change Vehicle',

  PRODUCT_REPEATER_CLASS: 'product-list product-list--collection product-list--with-sidebar',

  SELECT_YOUR_VEHICLE: '<rt-virtual template="icons/vehicle" /> Select Your Vehicle',

  SINGLE_VEHICLE_GARAGE_CLEAR: '<rt-virtual template="icons/times" />',

  VERIFY_FITMENT_FITS: 'This Product Fits your',
  VERIFY_FITMENT_NOT_FIT: 'This Product does not fit your',
  VERIFY_FITMENT_COMPATIBLE_PARTS: 'See Matching Parts',
  VERIFY_FITMENT_ICON: `
  <rt-virtual rt-if="this.fits === 'yes' || this.fits === 'universal'" template="icons/fits" />
  <rt-virtual rt-if="this.fits === 'no'" template="icons/no-fits" />
  <rt-virtual rt-if="this.fits === 'unknown'" template="icons/questionmark" />
  <rt-virtual rt-if="this.fits === 'aggressive'" template="icons/exclamationmark" />`,
};
